import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Login';
import EmailManager from './EmailManager';

const App = () => {
    return (
      <div>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/emails" element={<EmailManager />} />
            <Route path="/" element={<Navigate to="/login" />} />
          </Routes>
        </Router>
      </div>
    );
};

export default App;
